import classNames from './LevelSettingsConfirmModal.module.scss';
import classes from 'classnames';
import { useTranslation } from 'react-i18next';
import { Transition } from 'react-transition-group';

import TheButton from '@/components/TheButton/TheButton';
import AppBackdrop from '@/components/AppBackdrop';
import AppModal from '@/components/AppModal';

interface LevelSettingsConfirmModalProps {
  show: boolean;
  /** One message per changed setting; rendered sequentially in a single modal. */
  messages: string[];
  /** Action-specific confirm button text (e.g. "Disable Level Test"). Falls back to "Confirm". */
  confirmLabel?: string;
  onConfirm: () => void;
  onCancel: () => void;
}

/**
 * "Are you sure?" interceptor shown when a teacher creates or edits a class's level control
 * settings (placementTestRequired / defaultStartingLevel / allowIndividualAdvancement).
 * See ELL-7746.
 */
const LevelSettingsConfirmModal = ({
  show,
  messages,
  confirmLabel,
  onConfirm,
  onCancel,
}: LevelSettingsConfirmModalProps) => {
  const { t } = useTranslation();

  return (
    <Transition
      in={show}
      timeout={400}
      mountOnEnter
      unmountOnExit
      children={state => {
        return (
          <>
            <AppBackdrop className={classes(classNames.backdrop, `backdrop-${state}`)} />
            <AppModal className={classNames.appModal}>
              <div className={classes(classNames.modal, `fade-${state}`)}>
                <h2>{t('admin.schoolDetailsPage.classes.levelControl.confirmTitle')}</h2>
                {messages.map((message, index) => (
                  <span key={index} className={classNames.description}>
                    {message}
                  </span>
                ))}

                <div className={classNames.actions}>
                  <TheButton
                    className={classNames.confirmBtn}
                    text={
                      confirmLabel ??
                      t('admin.schoolDetailsPage.classes.levelControl.confirmButton')
                    }
                    shouldRecolor={false}
                    emitOnClick={onConfirm}
                  />
                  <button type='button' className={classNames.cancelBtn} onClick={onCancel}>
                    {t('admin.schoolDetailsPage.classes.levelControl.cancelButton')}
                  </button>
                </div>
              </div>
            </AppModal>
          </>
        );
      }}
    />
  );
};

export default LevelSettingsConfirmModal;
